import React from 'react';

const InputSaveBtn = () => {
  return (
    <div className="InputSaveBtn">
      <input type="submit" value = "저장" className = "btn-admin btn-admin-save"/>
    </div>
  );
}

export default InputSaveBtn;